import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import PropTypes from "prop-types";

const StateForm = ({ show, onClose, onSubmit, initialData, loading }) => {
    const [code, setCode] = useState("");
    const [name, setName] = useState("");
    const [errors, setErrors] = useState({});

    /* -------------------------------------------------------------------------- */
    /* LOAD DATA FOR EDIT                                                         */
    /* -------------------------------------------------------------------------- */
    useEffect(() => {
        if (initialData) {
            setCode(initialData.code || "");
            setName(initialData.name || "");
        } else {
            setCode("");
            setName("");
        }
    }, [initialData]);

    /* -------------------------------------------------------------------------- */
    /* VALIDATION                                                                 */
    /* -------------------------------------------------------------------------- */
    const validate = () => {
        const newErrors = {};

        if (!code.trim()) newErrors.code = "State code is required";
        if (code.length < 2 || code.length > 3)
            newErrors.code = "Code must be 2–3 characters";

        if (!name.trim()) newErrors.name = "State name is required";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    /* -------------------------------------------------------------------------- */
    /* SUBMIT HANDLER                                                             */
    /* -------------------------------------------------------------------------- */
    const handleSubmit = () => {
        if (!validate()) return;

        onSubmit({
            code: code.toUpperCase(),
            name: name.trim()
        });
    };

    return (
        <Modal show={show} onHide={onClose} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>
                    {initialData ? "Update State" : "Add State"}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>State Code</Form.Label>
                        <Form.Control
                            type="text"
                            value={code}
                            maxLength={3}
                            disabled={!!initialData} // disable on edit
                            onChange={(e) => setCode(e.target.value)}
                            isInvalid={!!errors.code}
                            placeholder="KA"
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.code}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group>
                        <Form.Label>State Name</Form.Label>
                        <Form.Control
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            isInvalid={!!errors.name}
                            placeholder="Karnataka"
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.name}
                        </Form.Control.Feedback>
                    </Form.Group>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onClose}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                    {loading ? "Saving..." : initialData ? "Update" : "Create"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

StateForm.propTypes = {
    show: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialData: PropTypes.object,
    loading: PropTypes.bool
};

export default StateForm;
